import React, { useState, useEffect } from 'react';
import './NavBar.css';

const NavBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    if (isMenuOpen) {
      setIsMenuOpen(false);
    }
  };

  const scrollToWaitlist = (e) => {
    e.preventDefault();
    const waitlistSection = document.getElementById('waitlist-section');
    if (waitlistSection) {
      const waitlistPosition = waitlistSection.getBoundingClientRect().top + window.pageYOffset;
      const offset = 30; // Same offset as in the Hero component
      window.scrollTo({
        top: waitlistPosition - offset,
        behavior: 'smooth'
      });
    }
    // Close mobile menu if open
    closeMenu();
  };

  useEffect(() => {
    // Use IntersectionObserver with lower offset and threshold for smoother transitions
    const options = {
      root: null, // Use the viewport
      rootMargin: '-50px 0px', // Smaller offset to detect sections earlier
      threshold: 0.1, // Lower threshold to detect sections more quickly
    };

    // Track which sections are currently visible
    const visibleSections = {
      'home': false,
      'value-prop': false,
      'about': false,
      'faq': false,
      'cta': false,
      'footer': false,
    };

    const observer = new IntersectionObserver((entries) => {
      // Update visibility status for each section
      entries.forEach(entry => {
        const id = entry.target.id;
        if (id === '') return;
        
        visibleSections[id] = entry.isIntersecting;
      });

      // Determine active section based on priority
      if (visibleSections['cta'] || visibleSections['footer']) {
        setActiveSection('none');
      } else if (visibleSections['faq']) {
        setActiveSection('faq');
      } else if (visibleSections['about']) {
        setActiveSection('about');
      } else if (visibleSections['value-prop']) {
        setActiveSection('value-prop');
      } else if (visibleSections['home']) {
        setActiveSection('home');
      } else if (window.scrollY < 100) {
        // Fallback for top of page
        setActiveSection('home');
      }
    }, options);

    // Observe all sections
    const sectionsToObserve = [
      document.getElementById('home'), // Now using the ID we added to Hero
      document.getElementById('value-prop'),
      document.getElementById('about'),
      document.getElementById('faq'),
      document.getElementById('cta'),
      document.getElementById('footer'),
    ];

    // Start observing each section
    sectionsToObserve.forEach(section => {
      if (section) {
        observer.observe(section);
      }
    });

    // Add scroll listener for edge case at top of page
    const handleScroll = () => {
      if (window.scrollY < 100 && !visibleSections['value-prop'] && 
          !visibleSections['about'] && !visibleSections['faq'] &&
          !visibleSections['cta'] && !visibleSections['footer']) {
        setActiveSection('home');
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup
    return () => {
      sectionsToObserve.forEach(section => {
        if (section) {
          observer.unobserve(section);
        }
      });
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-brand">
          <a href="/" className="logo">
            <img src="/attenxion_logo_blue.png" alt="Attenxion" className="logo-image" />
          </a>
        </div>
        
        <div className={`navbar-links ${isMenuOpen ? 'active' : ''}`}>
          <a href="/#home" className={`nav-link ${activeSection === 'home' ? 'active' : ''}`} onClick={closeMenu}>Home</a>
          <a href="#value-prop" className={`nav-link ${activeSection === 'value-prop' ? 'active' : ''}`} onClick={closeMenu}>Features</a>
          <a href="#about" className={`nav-link ${activeSection === 'about' ? 'active' : ''}`} onClick={closeMenu}>About</a>
          <a href="#faq" className={`nav-link ${activeSection === 'faq' ? 'active' : ''}`} onClick={closeMenu}>FAQ</a>
          <a 
            href="#waitlist-section" 
            className="contact-us-button"
            onClick={scrollToWaitlist}
          >
            Contact Us
          </a>
        </div>

        <button className={`hamburger ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>
      </div>
    </nav>
  );
};

export default NavBar; 